import { useState, useMemo, useEffect } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { createStandardCachedResolver } from 'reference-resolvers-lite/utils/createStandardCachedResolver';
import { usePagedSearchResolver } from 'reference-resolvers-lite/ResolverHooks';
import { FORM } from 'customer-data-objects/externalOptions/ExternalOptionsReferenceTypes';
import { CONTACT_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import SelectionPanel from 'automation-ui-canvas/create/SelectionPanel';
import { jsx as _jsx } from "react/jsx-runtime";
const PAGE_SIZE = 100;
export default function FormSelectionPanel({
  onClose,
  stagedTriggerOption,
  onSelectTriggerOption
}) {
  var _results$hasMore, _results$offset;
  const resolver = useMemo(() => createStandardCachedResolver(FORM, CONTACT_ID), []);
  const [isLoading, setIsLoading] = useState(true);
  const [queryObject, setQueryObject] = useState({
    query: '',
    count: PAGE_SIZE,
    offset: 0
  });
  const [references, setReferences] = useState([]);
  const {
    results
  } = usePagedSearchResolver(resolver, queryObject);
  const hasMore = (_results$hasMore = results === null || results === void 0 ? void 0 : results.hasMore) !== null && _results$hasMore !== void 0 ? _results$hasMore : false;
  const offset = Number((_results$offset = results === null || results === void 0 ? void 0 : results.offset) !== null && _results$offset !== void 0 ? _results$offset : 0);
  useEffect(() => {
    if (results) {
      const startIndex = offset - results.references.length;
      setReferences(currentReferences => currentReferences.slice(0, startIndex).concat(results.references));
      setIsLoading(false);
    }
  }, [results, offset]);
  const referenceOptions = references.map(({
    id,
    label,
    description
  }) => ({
    value: id,
    text: label,
    help: description
  }));
  const options = [{
    value: '',
    text: I18n.text('createWorkflow.formSelectionPanel.anyForm')
  }, ...referenceOptions];
  return /*#__PURE__*/_jsx(SelectionPanel, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "createWorkflow.formSelectionPanel.title"
    }),
    options: options,
    searchTerm: queryObject.query,
    onSearchTermChange: newQuery => {
      setQueryObject(({
        count
      }) => ({
        query: newQuery,
        count,
        offset: 0
      }));
      setReferences([]);
      setIsLoading(true);
    },
    onClose: onClose,
    onSelectOption: ({
      value
    }) => {
      let filters;
      if (value !== '') {
        filters = [{
          filterType: 'PROPERTY',
          property: 'hs_form_id',
          operation: {
            propertyType: 'enumeration',
            operator: 'IS_ANY_OF',
            values: [value],
            defaultValue: null,
            includeObjectsWithNoValueSet: false,
            operationType: 'enumeration',
            operatorName: 'IS_ANY_OF'
          },
          frameworkFilterId: null
        }];
      }
      onSelectTriggerOption(Object.assign({}, stagedTriggerOption, {
        filters
      }));
    },
    loading: isLoading,
    hasMore: hasMore,
    loadMore: () => {
      setQueryObject(({
        query,
        count
      }) => ({
        query,
        count,
        offset
      }));
      setIsLoading(true);
    }
  });
}